import { ProjectStatusE } from "../../../models/enums";
import { UnfinishedDeliveryT } from "../models";

export default (item: UnfinishedDeliveryT): string => {
    if (!item) return 'transparent';
    if (item?.projectStatus === ProjectStatusE.Opened) return '#34A7F0';
    if (item?.projectStatus === ProjectStatusE.WaitingForApprovalOfPostProduction) return '#fec92e';
    return '#1ab878'
    return '';
};